export class Answersheet {
    private id: String = '';
    private questionnaireId: String = '';
    private collectedAt: Number = 0;
    private flags = {};
    private answers: Array<{}> = [];
    private locale: String = '';
    private sensordata = {};
    private client = {};
    private userId = null;

    public constructor(id: String) {
        this.id = id;
    }

    public setId(id: String) { this.id = id; }
    public getId() { return this.id; }
    public setQuestionnaireId(id: String) { this.questionnaireId = id; }
    public getQuestionnaireId() { return this.questionnaireId; }
    public setCollectedAt(coll: Number) { this.collectedAt = coll; }
    public getCollectedAt() { return this.collectedAt; }
    public setFlags(flags) { this.flags = flags; }
    public setAnswers(answers: Array<{}>) { this.answers = answers; }
    public getAnswers() { return this.answers; }
    public addAnswers(answers: Array<{}>) { this.answers.concat(answers); }
    public setLocale(locale: String) { this.locale = locale; }
    public getLocale() { return this.locale; }
    public setSensorData(data) { this.sensordata = data; }
    public getSensorData() { return this.sensordata; }
    public setClient(client) { this.client = client; }
    public getClient() { return this.client; }
    public setUserId(userId) { this.userId = userId; }
    public getUserId() { return this.userId; }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/models/answersheet.ts